import cn from 'classnames'
import { TextAreaInputVariant } from 'ext-ui/components/TextAreaInput/TextAreaInput'
import React, { ComponentProps, forwardRef } from 'react'

import styles from './TextAreaInputInternal.style'

type TextAreaInputInternalProps = ComponentProps<'textarea'> & {
  variant: TextAreaInputVariant
}

const TextAreaInputInternal = forwardRef<
  HTMLTextAreaElement,
  TextAreaInputInternalProps
>((props, ref) => {
  const { variant, className, disabled, readOnly, value, ...rest } = props
  return (
    <textarea
      css={styles}
      className={cn(className, variant)}
      disabled={disabled}
      value={value}
      readOnly={readOnly}
      {...rest}
      ref={ref}
    />
  )
})

export default TextAreaInputInternal
